import React from "react";
import PropTypes from "prop-types";
import { Formik, Form, Field } from "formik";
import styled from "styled-components";
import YMMTSelect from "../containers/YMMTSelectContainer";
import { CallToActionButton } from "./Buttons";
import useAccountSettings from "../hooks/useAccountSettings";
import { withTheme } from "@material-ui/styles";
import { SearchByHeader } from "../containers/Search";

const FormStyled = withTheme(styled(Form)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`);

const YMMTSelectStyled = styled(YMMTSelect)`
  flex-grow: 1;
`;

const SubmitButton = styled(CallToActionButton).attrs({ type: "submit" })`
  && {
    margin-top: 10px;
  }
`;

const YMMTSelectField = ({ field, ...props }) => {
  const { onChange, value: ymmtIds, name } = field;
  return (
    <YMMTSelectStyled name={name} onChange={onChange} {...ymmtIds} {...props} />
  );
};

const validate =
  (trimOptional) =>
  ({ ymmtIds = {} }) => {
    const { yearId, makeId, modelId, trimId } = ymmtIds;
    switch (true) {
      case !yearId:
        return { ymmtIds: "No year selected" };
      case !makeId:
        return { ymmtIds: "No make selected" };
      case !modelId:
        return { ymmtIds: "No model selected" };
      case !trimId && !trimOptional:
        return { ymmtIds: "No trim selected" };
      default:
        return {};
    }
  };

const YMMTForm = ({
  onSubmit,
  accountId,
  trimOptional,
  action,
  initialYMMT,
}) => {
  const handleSubmit = (values) => onSubmit(values);
  const [{ franchises }] = useAccountSettings({ accountId });

  return (
    <Formik
      validate={validate(trimOptional)}
      onSubmit={handleSubmit}
      initialValues={{ ymmtIds: initialYMMT }}
      isInitialValid={({ validate, initialValues }) =>
        Object.keys(validate(initialValues)).length === 0
      }
    >
      {(props) => (
        <FormStyled>
          <SearchByHeader>
            Search by <strong>Model</strong>
          </SearchByHeader>
          <Field
            name="ymmtIds"
            component={YMMTSelectField}
            franchises={franchises}
          />
          <SubmitButton disabled={!props.isValid}>{action}</SubmitButton>
        </FormStyled>
      )}
    </Formik>
  );
};

YMMTForm.propTypes = {
  onSubmit: PropTypes.func,
};

YMMTForm.defaultProps = {
  onSubmit: () => {},
  action: "Get Your Report",
};

export default YMMTForm;
